import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-detail" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = {
  key: 0,
  class: "print-config"
}
const _hoisted_4 = {
  key: 1,
  class: "no-config"
}
const _hoisted_5 = { class: "dialog-footer" }

import { ref, watch } from 'vue';
import { getStatusLabel } from './docgenerator';


export default /*@__PURE__*/_defineComponent({
  __name: 'detail',
  props: {
    modelValue: { type: Boolean },
    orderData: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visible = ref(false);

// 监听props变化
watch(() => props.modelValue, (newVal) => {
  visible.value = newVal;
}, { immediate: true });

// 监听visible变化
watch(visible, (newVal) => {
  emit('update:modelValue', newVal);
});

const handleClose = () => {
  visible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    title: "订单详情",
    width: "60%",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, { onClick: handleClose }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode("关闭")
          ])),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_card, {
          class: "detail-card",
          shadow: "never"
        }, {
          header: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("span", null, "订单基础信息")
            ], -1)
          ])),
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions, {
              column: 2,
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "订单编号" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.orderData.id || '无'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "订单名称" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.orderData.name || '无'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "订单状态" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tag, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getStatusLabel)(_ctx.orderData.status)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "创建时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.orderData.createTime || '无'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "用户ID" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.orderData.userId || '无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          class: "detail-card",
          shadow: "never"
        }, {
          header: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("span", null, "收货地址信息")
            ], -1)
          ])),
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions, {
              column: 2,
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "收货人" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.orderData.postinfo?.name || '无'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "联系电话" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.orderData.postinfo?.phone || '无'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: "收货地址",
                  span: 2
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.orderData.postinfo?.address || '无'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          class: "detail-card",
          shadow: "never"
        }, {
          header: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("span", null, "价格信息")
            ], -1)
          ])),
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions, {
              column: 3,
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "打印费用" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.orderData.printPrice || '0') + "元", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "邮寄费用" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.orderData.postPrice || '0') + "元", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "订单总价" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.orderData.totalPrice || '0') + "元", 1)
                  ]),
                  _: 1
                }),
                (_ctx.orderData.discountPrice)
                  ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                      key: 0,
                      label: "优惠金额"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.orderData.discountPrice) + "元", 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.orderData.realPrice)
                  ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                      key: 1,
                      label: "实际支付"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.orderData.realPrice) + "元", 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.orderData.realNo || _ctx.orderData.postcode)
          ? (_openBlock(), _createBlock(_component_el_card, {
              key: 0,
              class: "detail-card",
              shadow: "never"
            }, {
              header: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("span", null, "物流信息")
                ], -1)
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions, {
                  column: 2,
                  border: ""
                }, {
                  default: _withCtx(() => [
                    (_ctx.orderData.realNo)
                      ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                          key: 0,
                          label: "真实订单号"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.orderData.realNo), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.orderData.postcode)
                      ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                          key: 1,
                          label: "快递单号"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.orderData.postcode), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.orderData.reason || _ctx.orderData.backPrice || _ctx.orderData.processResult)
          ? (_openBlock(), _createBlock(_component_el_card, {
              key: 1,
              class: "detail-card",
              shadow: "never"
            }, {
              header: _withCtx(() => _cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("span", null, "售后信息")
                ], -1)
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions, {
                  column: 2,
                  border: ""
                }, {
                  default: _withCtx(() => [
                    (_ctx.orderData.reason)
                      ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                          key: 0,
                          label: "售后原因",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.orderData.reason), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.orderData.backPrice)
                      ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                          key: 1,
                          label: "退款金额"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.orderData.backPrice) + "元", 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.orderData.processResult)
                      ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                          key: 2,
                          label: "处理结果"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.orderData.processResult), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.orderData.coupon)
          ? (_openBlock(), _createBlock(_component_el_card, {
              key: 2,
              class: "detail-card",
              shadow: "never"
            }, {
              header: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("span", null, "优惠券信息")
                ], -1)
              ])),
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions, {
                  column: 2,
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_descriptions_item, { label: "优惠券名称" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.orderData.coupon.name || '无'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "优惠券面额" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.orderData.coupon.price || '0') + "元", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "使用门槛" }, {
                      default: _withCtx(() => [
                        _createTextVNode("满" + _toDisplayString(_ctx.orderData.coupon.minPrice || '0') + "元可用", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "有效期至" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.orderData.coupon.expireAt || '无'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_card, {
          class: "detail-card",
          shadow: "never"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "打印文件信息", -1)),
              _createVNode(_component_el_tag, { type: "info" }, {
                default: _withCtx(() => [
                  _createTextVNode("共 " + _toDisplayString(_ctx.orderData.prints?.length || 0) + " 个文件", 1)
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: _ctx.orderData.prints,
              border: "",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "文件名",
                  "min-width": "150"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "ext",
                  label: "格式",
                  width: "80"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_tag, { size: "small" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.ext?.toUpperCase() || '未知'), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "pageCount",
                  label: "页数",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "fileSize",
                  label: "文件大小",
                  width: "100"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.fileSize ? `${(scope.row.fileSize / 1024).toFixed(2)}KB` : '未知'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "price",
                  label: "打印费用",
                  width: "100"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.price || '0') + "元 ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "打印配置",
                  "min-width": "200"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.meta)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (scope.row.meta.name)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 0,
                                size: "small",
                                class: "config-tag"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.meta.name), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (scope.row.meta.color)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 1,
                                size: "small",
                                class: "config-tag"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.meta.color), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (scope.row.meta.type)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 2,
                                size: "small",
                                class: "config-tag"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.meta.type), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (scope.row.meta.zdType)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 3,
                                size: "small",
                                class: "config-tag"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.meta.zdType), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (scope.row.meta.count)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 4,
                                size: "small",
                                class: "config-tag"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.meta.count) + "份", 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (scope.row.meta.range)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 5,
                                size: "small",
                                class: "config-tag"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.meta.range.join('-')) + "页 ", 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_4, "无配置信息"))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})